<template>
    <QualificationField
        :title="$t('profile.vetting.qualification.other.expertise.title')"
        :field-author-and-date="qualification.commentOnOtherExpertise"
        data-testid="admin-section-tabs-qualification-comment-on-other-expertise"
    >
        <VJoyTextarea
            v-if="profileQualificationStore.inEditMode"
            v-model="profileQualificationStore.qualificationUpdateForm.commentOnOtherExpertise"
            :placeholder="$t('profile.vetting.qualification.other.expertise.comment.placeholder')"
            autogrow
            data-testid="vetting-other-expertise-comment-edition"
        />
        <TextField
            v-else
            truncate
            :content="profileQualificationStore.qualificationUpdateForm.commentOnOtherExpertise"
            :replace-by="$t('profile.vetting.qualification.other.expertise.comment.empty.placeholder')"
            data-testid="vetting-other-expertise-comment"
        />
    </QualificationField>
    <QualificationField
        v-if="isListVisible"
        :title="$t('profile.vetting.qualification.other.expertise.title.list')"
        data-testid="admin-section-tabs-qualification-expertise-ratings"
    >
        <SkillRatingsField
            v-model:skill-ratings="profileQualificationStore.qualificationUpdateForm.otherSkillRatings"
            data-testid="vetting-other-expertise-ratings-edition"
        />
    </QualificationField>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {VJoyTextarea} from '@maltjoy/core-vue';
    import SkillRatingsField from '~/components/admin-section-tabs/qualification/SkillRatingsField.vue';
    import TextField from '~/components/admin-section-tabs/qualification/TextField.vue';
    import {useProfileQualificationStore} from '~/store/profileQualificationStore';
    import QualificationField from './ui/QualificationField.vue';

    const profileQualificationStore = useProfileQualificationStore();

    const {qualification} = storeToRefs(profileQualificationStore);

    const isListVisible = computed(() => profileQualificationStore.qualificationUpdateForm.otherSkillRatings.length > 0);
</script>
